import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import AuthFooter from '../components/shared/AuthFooter/AuthFooter'
import RestoreWallet from '../components/RestoreWallet/RestoreWallet'
import { WALLET_RESTORE_ACTIONS } from '../store/actions/wallet'
import { RECEIVE_WALLET_NAV } from '../constants/navigation'
import requireWallet from '../hoc/requireWallet'
import { containsNoErrors } from '../util/helpers'
import { getMnemonicErrors, getPasswordErrors } from '../util/errors'
import brandingService from '../services/branding'

const TEXT_MESSAGES = {
  mnemonic: '',
  password: '',
  passwordRepeat: ''
}

class RestoreWalletContainer extends Component {

  state = {
    showSecure: false,
    showQrReader: false,
    errorMessages: TEXT_MESSAGES,
    checkboxError: false,
    checkboxSelected: false
  }

  componentDidUpdate() {
    const { restoreProfile, history, wallet, brandData } = this.props
    if (restoreProfile.restored) {
      if (brandData.redirect) {
        brandingService.redirectToBrand(brandData.redirect, wallet.address)
      }
      history.push(RECEIVE_WALLET_NAV)
    }
  }

  componentWillUnmount() {
    this.props.resetWalletRestoreState()
  }

  onRestoreWithMnemonic = () => {
    const { restoreProfile } = this.props
    this.setState({
      errorMessages: getMnemonicErrors(restoreProfile)
    }, () => {
      if (containsNoErrors(this.state.errorMessages)) {
        this.setState({
          showSecure: true,
        })
      }
    })
  }

  handleShowQrReader = () => {
    this.setState({
      showQrReader: !this.state.showQrReader
    })
  }

  handleScan = (data) => {
    if (data) {
      this.setState({
        errorMessages: getMnemonicErrors({ mnemonic: data, fromScan: true })
      }, () => {
        if (containsNoErrors(this.state.errorMessages)) {
          this.setState({
            showSecure: true,
            showQrReader: false,
          })
          this.props.onMnemonicChange(data)
        }
      })
    }
  }

  handleScanError = () => {
    this.setState({
      showQrReader: !this.state.showQrReader,
      errorMessages: {mnemonic: 'error-messages.camera-not-allowed'}
    })
  }

  onSecureRestoredWallet = (mnemonic, password) => {
    const { checkboxSelected } = this.state
    const { restoreProfile } = this.props
    this.setState({
      errorMessages: getPasswordErrors(restoreProfile)
    }, () => {
      if (!checkboxSelected) {
        return this.setState({
          checkboxError: true
        })
      }
      if (containsNoErrors(this.state.errorMessages)) {
        this.props.onRestoreWallet(mnemonic, password)
      }
    })    
  }

  onCheckboxClick = () => {
    this.setState({
      checkboxSelected: !this.state.checkboxSelected,
      checkboxError: false
    })
  }

  render() {
    return (
      <div className="main-container main-container--flex-column">
        <RestoreWallet
          {...this.props}
          {...this.state}
          showSecure={this.state.showSecure}
          showQrReader={this.state.showQrReader}
          handleShowQrReader={this.handleShowQrReader}
          handleScanError={this.handleScanError}
          handleScan={this.handleScan}
          onRestoreWithMnemonic={this.onRestoreWithMnemonic}
          onSecureRestoredWallet={this.onSecureRestoredWallet}
          onCheckboxClick={this.onCheckboxClick}
        />
        <AuthFooter />
      </div>
    )
  }
}

const mapStateToProps = ({ walletReducer, authReducer }) => {
  return {
    restoreProfile: walletReducer.restoreProfile,
    brandData: authReducer.brandData
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    ...WALLET_RESTORE_ACTIONS
  }, dispatch)

export default requireWallet(connect(mapStateToProps, mapDispatchToProps)(RestoreWalletContainer))







// WEBPACK FOOTER //
// ./src/containers/RestoreWalletContainer.js